export default "__VITE_ASSET__Ba6TjlMg__"